<template>
  <VList
    :elevation="elevation"
    :border="border"
    :disabled="disabled"
    :density="density"
  >
    <slot />
  </VList>
</template>

<script setup lang="ts">
import { VList } from 'vuetify/components/VList';

type Density = 'default' | 'comfortable' | 'compact';

export interface Props {
  elevation?: string | number;
  border?: string | number;
  disabled?: boolean;
  density?: Density;
}

withDefaults(defineProps<Props>(), {
  elevation: undefined,
  border: 0,
  density: 'default',
  disabled: undefined,
});
</script>
